var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaylistDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#727271",
    d: "M8.27 15.6c0 .48-.42.9-.93.9a.92.92 0 0 1-.92-.9v-5.54c0-.49.41-.9.92-.9s.93.41.93.9v5.53z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#727271",
    d: "M1.83 3.68h18.36v12.16A6.13 6.13 0 0 1 14.04 22H7.99a6.13 6.13 0 0 1-6.15-6.16V3.68zM3.66 5.5v10.33c0 1.17.49 2.24 1.24 3.02.78.78 1.9 1.24 3.08 1.24h6.07a4.25 4.25 0 0 0 4.24-4.26V5.5H3.66z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#727271",
    d: "M11.93 15.6c0 .48-.42.9-.93.9a.92.92 0 0 1-.93-.9v-5.54c0-.49.42-.9.93-.9s.93.41.93.9v5.53zm3.66 0c0 .48-.42.9-.93.9a.92.92 0 0 1-.9-.9v-5.54a.92.92 0 0 1 1.83 0v5.53z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M16.51 5.5V2.59c0-.2-.07-.39-.22-.53a.82.82 0 0 0-.53-.22h-9.5a.8.8 0 0 0-.53.22.76.76 0 0 0-.22.53v2.93H3.66V2.58c0-.7.3-1.36.78-1.82C4.9.29 5.54 0 6.27 0h9.49a2.56 2.56 0 0 1 2.58 2.58v2.93h-1.83z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#727271",
    d: "M21.1 3.65c.51 0 .9.42.9.93a.9.9 0 0 1-.9.93H.9a.92.92 0 0 1-.9-.93c0-.51.41-.93.9-.93h20.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistDelete);
export default __webpack_public_path__ + "static/media/playlist-delete.4d87c5dd9462cd97a140c1e541e9f292.svg";
export { ForwardRef as ReactComponent };